import { mountStoreDevtool } from 'simple-zustand-devtools'
import { ICarrinhoData } from 'types/carrinho'
import { create } from 'zustand'
import { combine, createJSONStorage, persist } from 'zustand/middleware'

interface CarrinhoInfo {
  current_cart: ICarrinhoData
  carrinho_tamanho: number
  checkboxDiscontTax: boolean
  tipo_desconto: string
  mensagem_status_inclusao: string
  tipo_operacao: string
  id_desconto_document: number
  savedCartName: string
}
const cartDefault: ICarrinhoData = {
  qt_total_cotas: 0,
  vl_total_credito: 0,
  vl_total_parcela: 0
}
const DEFAULT_GLOBAL_INFO: CarrinhoInfo = {
  current_cart: cartDefault,
  carrinho_tamanho: 0,
  checkboxDiscontTax: true,
  tipo_desconto: '',
  mensagem_status_inclusao: '',
  tipo_operacao: '',
  id_desconto_document: 0,
  savedCartName: ''
}

const useCarrinhoStore = create(
  persist(
    combine(DEFAULT_GLOBAL_INFO, (set) => ({
      setCarrinhoTamanho: (carrinho_tamanho: number) => set({ carrinho_tamanho }),
      setCheckboxDiscontTax: (checkboxDiscontTax: boolean) => set({ checkboxDiscontTax }),
      setTipoDesconto: (tipo_desconto: string) => set({ tipo_desconto }),
      setMensagemStatusInclusao: (mensagem_status_inclusao: string) =>
        set({ mensagem_status_inclusao }),
      setTipoOperacao: (tipo_operacao: string) => set({ tipo_operacao }),
      resetCarrinhoStore: () => set(DEFAULT_GLOBAL_INFO),
      setCurrentCart: (current_cart: ICarrinhoData) => set({ current_cart }),
      setDiscontByDocument: (id_desconto_document: number) => {
        if (typeof id_desconto_document !== 'number') {
          throw new Error('O desconto deve ser um número.')
        }
        set({ id_desconto_document })
      },
      setSavedCartName: (savedCartName: string) => set({ savedCartName })
    })),
    {
      name: 'cart-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Carrinho Store', useCarrinhoStore)
}

export default useCarrinhoStore
